import type { DesignRequestKind, DesignRequestStatus } from '@ghostscreen/contracts';
import { formatDateTime, formatList, i18n } from '../../i18n';

export const DESIGN_KINDS: DesignRequestKind[] = [
  'menu_board',
  'promotion',
  'opening_hours',
  'welcome_screen',
  'other',
];

/** Labels live under `designer:status.<status>`. */
export const STATUS_PILL: Record<DesignRequestStatus, { color: string }> = {
  sent: { color: 'var(--gs-warn)' },
  designing: { color: 'var(--gs-warn)' },
  review: { color: 'var(--gs-accent)' },
  live: { color: 'var(--gs-ok)' },
};

export const STATUS_STEP_INDEX: Record<DesignRequestStatus, number> = {
  sent: 0,
  designing: 1,
  review: 2,
  live: 3,
};

/** Labels live under `designer:steps.<step>`. */
export const STATUS_STEPS = ['sent', 'designing', 'review', 'live'] as const;

export function formatSentDate(iso: string): string {
  return formatDateTime(iso, { day: 'numeric', month: 'short' });
}

export function statusNote(input: {
  status: DesignRequestStatus;
  changeRequest: string;
  approvedAt: string | null;
  createdAt: string;
  screenNames: string[];
}): string {
  switch (input.status) {
    case 'sent':
      return i18n.t('designer:notes.sent');
    case 'designing':
      return input.changeRequest
        ? i18n.t('designer:notes.designingChanges', { change: input.changeRequest })
        : i18n.t('designer:notes.designing');
    case 'review':
      return i18n.t('designer:notes.review');
    case 'live': {
      const date = formatSentDate(input.approvedAt || input.createdAt);
      return input.screenNames.length > 0
        ? i18n.t('designer:notes.liveOnScreens', { date, screens: formatList(input.screenNames) })
        : i18n.t('designer:notes.liveSaved', { date });
    }
  }
}
